/** @jsx jsx */
import { jsx } from '@emotion/core'
import { getClientInfo } from 'core'
import React from 'react'
import { connect } from 'react-redux'

const cellStyle = {
  paddingBottom: '2px',
  paddingTop: '2px',
  // borderBottom: '1px solid #ccc',
  border: '1px solid #ccc',
  height: '18px',
  padding: '0px',
  fontSize: '0.75em',
  fontWeight: 'normal',
  paddingRight: '2px',
}

// const Header = styled.div`
//   border: 1px solid rgb(204, 204, 204);
//   background-color: #eeeeee;
//   color: black;
//   text-align: center;
//   height: 18px;
//   font-size: 0.85em;
//   font-weight: normal;

const PiaTableInfoAntd = ({ data, width }) => {
  const loadData = (type, cellStyle, otherLabel, title) => {
    const b = data.find(t => t.item === type)
    if (b === undefined) return ''
    const rgb = `rgb(${b.red},${b.green},${b.blue},0.5)`

    return [
      <div
        style={cellStyle}
        key={otherLabel || b.item}
        css={{ padding: '1px', textAlign: 'center' }}
        title={title}
      >
        {otherLabel || b.item}
      </div>,
      // <div
      //   style={{ backgroundColor: rgb, ...cellStyle, textAlign: 'right' }}
      //   inverted
      //   key={b.thrs}
      // >
      //   {b.thrs}
      // </div>,
      <div
        style={{
          backgroundColor: rgb,
          ...cellStyle,
          textAlign: 'right',
          paddingRight: '2px',
        }}
        inverted
        key={b.percent}
      >
        {b.percent} %
      </div>,
    ]
  }

  if (data === undefined || data.length === 0) return <div />

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '80px 80px',
        alignContent: 'baseline',
        width: width,
        // marginRight: '10px',
        // padding: 10,
      }}
    >
      {/* <Header>Name</Header>
      <Header style={{ textAlign: 'right', minWidth: '50px' }}>%</Header> */}
      {loadData('SIHD', cellStyle, null, 'Service Inverter Hours (Day)')}
      {loadData('RSIHD', cellStyle, null)}
      {loadData('FOIHD', cellStyle, null, 'Forced Outage Inverter Hours (Day)')}
      {loadData('MIHD', cellStyle, null, 'Maintenance Inverter Hours (Day)')}
      {loadData('PIHD', cellStyle, null, 'Planned Inverter Hours (Day)')}
      {loadData(
        'RUIHD',
        cellStyle,
        null,
        'Resource Unavailable Inverter Hours (Day)'
      )}
      {loadData('IRIH', cellStyle, null, 'Inactive Reserve Inverter Hours')}
      {loadData('MBIH', cellStyle, null, 'Mothballed Inverter Hours')}
      {loadData('RIH', cellStyle, null, 'Retired Unit Inverter Hours')}
    </div>
  )
}

const mapStateToProps = state => ({
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(PiaTableInfoAntd)
